// Third party libraries
import DatePicker from 'vue2-datepicker';

// Components

// Mixins
import { tableMixins } from '@/app/mixins/utils/table-mixins.js';
import { toastMessageMixins } from '@/app/mixins/utils/toast-message-mixins.js';
import { dateMixins } from "@/app/mixins/utils/date-mixins";

// Services
import puppySellService from "@/app/services/main/puppy-sell/puppy-sell-service.js"

// Constants
import { STATUS_CODES, PUPPY_SELL_STATUS, USER_TYPE } from "@/app/constants/constants"


export default {
	name: 'PuppyPaymentListContainer',
    components: {
        DatePicker
    },
	mixins: [
		tableMixins,
		toastMessageMixins,
        dateMixins
	],
	computed: {
	},
	data() {
		return {
			isAPILoading: false,
			isBreedsLoading: false,
			// table
			theads: [
                {
                    name: "Sold Date", 
                    searchLabel: "f_soldDate", 
                    sortLabel: "soldDate",
                    isDesc: false, 
                    hasSearch: false ,
                    isSoldDate: true,
                    style: 'null',
                },
                {
                    name: "Company",
                    searchLabel: "f_companyName",
                    sortLabel: "companyName",
                    isDesc: false,
                    hasSearch: true,
                    style: "min-width: 150px",
                },
                {
                    name: "Contact",
                    searchLabel: "f_breederName",
                    sortLabel: "breederName",
                    isDesc: false,
                    hasSearch: true,
                    style: "min-width: 100px",
                },
                { 
                    name: "Client", 
                    searchLabel: "f_customerName", 
                    sortLabel: "customerName", 
                    isDesc: false, 
                    hasSearch: true,
                    style: "min-width: 150px",
                },
                {
                    name: "SKU",
                    searchLabel: "f_puppyReference",
                    sortLabel: "puppyReference",
                    isDesc: false,
                    hasSearch: true,
                    style: "min-width: 80px",
                },
                { 
                    name: "Puppy Price", 
                    searchLabel: "f_puppyPrice", 
                    sortLabel: "puppyPrice", 
                    isDesc: false, 
                    hasSearch: true,
                    style: "min-width: 100px",
                },
                { 
                    name: "Deposit Date", 
                    searchLabel: "f_depositDate", 
                    sortLabel: "depositDate", 
                    isDesc: false, 
                    isDepositDate: true 
                },
                { 
                    name: "Deposit", 
                    searchLabel: "f_depositAmount", 
                    sortLabel: "depositAmount", 
                    isDesc: false, 
                    hasSearch: true,
                    style: "min-width: 100px",
                },
                { 
                    name: "Balance Due Date", 
                    searchLabel: "f_balanceDueDate", 
                    sortLabel: "balanceDueDate", 
                    isDesc: false, 
                    isBalanceDueDate: true 
                },
                { 
                    name: "Balance", 
                    searchLabel: "f_balance", 
                    sortLabel: "balance", 
                    isDesc: false, 
                    hasSearch: true,
                    style: "min-width: 100px",
                },
                { 
                    name: null,
                     searchLabel: null, 
                     sortLabel: null, 
                     isDesc: false, hasSearch: false, style: null 
                },
            ],
			// sorting
			desc: true,
			sortBy: 'soldDate',
			modalContent: {},
            selectSoldDate: "",
            selectDepositDate: "",
            selectBalanceDueDate:"",
            userType: USER_TYPE
		}
	},
	created() {
		this.getTableContent();
	},
    watch: {
        selectSoldDate(){
            this.getTableContent();
        },
        selectDepositDate(){
            this.getTableContent();
        },
        selectBalanceDueDate(){
            this.getTableContent();
        }
    },
	methods: {
        redirectToDetails(type, id) {
            if (type === USER_TYPE.BRDER) {
                this.$router.push({ path: `/breeder-management/${id}/view`, query: {actionFrom: "payment-list" } });
            } else {
                this.$router.push(`/users/user/${id}`);
            }
           
        },
		getTableContent(fromFilter, page = this.page, limit = this.limit, sortBy = this.sortBy, desc = this.desc) {
            page = fromFilter ? 1 : this.page
            this.getPuppySellList({ page, limit, sortBy, desc })
        },
        getPuppySellList(queryParams) {
            // search filters
            if (this.columnsFilter) {
                const { 
                    f_balance,
                    f_balanceDueDate,
                    f_depositAmount,
                    f_depositDate,
                    f_puppyPrice,
                    f_puppyReference,
                    f_customerName,
                    f_breederName,
                    f_companyName,
                    f_soldDate
                } = this.columnsFilter
                    
                if (f_balance) {
                    queryParams["f_balance"] = f_balance
                }

                if (f_depositAmount) {
                    queryParams["f_depositAmount"] = f_depositAmount
                }

                if (f_puppyPrice) {
                    queryParams["f_puppyPrice"] = f_puppyPrice
                }

                if (f_puppyReference) {
                    queryParams["f_puppyReference"] = f_puppyReference
                }

                if (f_customerName) {
                    queryParams["f_customerName"] = f_customerName
                }

                if (f_breederName) {
                    queryParams["f_breederName"] = f_breederName
                }

                if (f_companyName) {
                    queryParams["f_companyName"] = f_companyName
                }

                if (this.selectSoldDate) {
                    queryParams["f_soldDate"] = this.formatDate(this.selectSoldDate, "yyyy-MM-dd HH:mm");
                }

                if (this.selectDepositDate) {
                    queryParams["f_depositDate"] = this.formatDateWithoutConversion(this.selectDepositDate, "yyyy-MM-dd HH:mm");
                }
                if (this.selectBalanceDueDate) {
                    queryParams["f_balanceDueDate"] = this.formatDateWithoutConversion(this.selectBalanceDueDate, "yyyy-MM-dd HH:mm");
                }
                
            }

            this.isAPILoading = true

            puppySellService.getPuppySellPaymentList(queryParams).then((res) => {
                if (res.status === STATUS_CODES.SUCCESS) {
                    this.tableContent = {
                        tableData: res.data.data
                            .map((dt) => {
                                return { ...dt }
                            })
                            .filter((dt) => dt.status != "DECLINED"),
                        paginationData: res.data.pagination,
                    }

                    this.isAPILoading = false
                } else {
                    this.showAPIErrorToast("Unable to fetch puppy sell list.", res)
                    this.isAPILoading = false
                }
            })
        },
        goBackToPuppiesForSale(){
            this.$router.push("/pet-purchases/puppy-selling");
        }
	}
}